class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    
    const topLevelDetails = this.mainDetailsToggle;
    const topLevelSummary = topLevelDetails ? topLevelDetails.querySelector('summary') : null;
    
    if (topLevelDetails && topLevelSummary) {
      // Top-level hover open
      topLevelDetails.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 990) {
          topLevelDetails.setAttribute('open', '');
          topLevelSummary.setAttribute('aria-expanded', true);
        }
      });

      // Top-level hover close (closes top-level AND collapses all nested submenus)
      topLevelDetails.addEventListener('mouseleave', () => {
        if (window.innerWidth >= 990) {
          this.close();
          // Collapse all nested details inside this menu
          const nestedDetails = this.querySelectorAll('details');
          nestedDetails.forEach(details => {
            if (details !== topLevelDetails) {
              details.removeAttribute('open');
              const nestedSummary = details.querySelector('summary');
              if (nestedSummary) nestedSummary.setAttribute('aria-expanded', false);
            }
          });
        }
      });

      // Top-level caret toggle behavior
      const topLevelToggle = topLevelSummary.querySelector('.header__menu-toggle');
      if (topLevelToggle) {
        topLevelToggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.close();
          // Collapse all nested details inside this menu
          const nestedDetails = this.querySelectorAll('details');
          nestedDetails.forEach(details => {
            if (details !== topLevelDetails) {
              details.removeAttribute('open');
              const nestedSummary = details.querySelector('summary');
              if (nestedSummary) nestedSummary.setAttribute('aria-expanded', false);
            }
          });
        });
      }

      // Top-level click navigate
      topLevelSummary.addEventListener('click', (event) => {
        if (window.innerWidth >= 990 && event.clientX > 0 && event.clientY > 0) {
          if (event.target.closest('.header__menu-toggle') || event.target.closest('.icon-caret')) {
            event.preventDefault();
            event.stopPropagation();
            this.close();
            // Collapse all nested details inside this menu
            const nestedDetails = this.querySelectorAll('details');
            nestedDetails.forEach(details => {
              if (details !== topLevelDetails) {
                details.removeAttribute('open');
                const nestedSummary = details.querySelector('summary');
                if (nestedSummary) nestedSummary.setAttribute('aria-expanded', false);
              }
            });
            return;
          }

          const url = topLevelSummary.getAttribute('data-url');
          if (url && url !== '#') {
            event.preventDefault();
            event.stopPropagation();
            window.location.href = url;
          }
        }
      });
    }

    // Bind event listeners for nested dropdown disclosures (levels 2 and below)
    const allDetails = this.querySelectorAll('details');
    allDetails.forEach(details => {
      if (details === topLevelDetails) return; // skip top-level
      
      const summary = details.querySelector('summary');
      if (!summary) return;

      // Nested hover open only (do NOT close on mouseleave to prevent layout shifting)
      details.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 990) {
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', true);
        }
      });

      // Nested caret toggle behavior
      const toggle = summary.querySelector('.header__menu-toggle');
      if (toggle) {
        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (details.hasAttribute('open')) {
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', false);
          } else {
            details.setAttribute('open', '');
            summary.setAttribute('aria-expanded', true);
          }
        });
      }

      // Nested click navigate
      summary.addEventListener('click', (event) => {
        if (window.innerWidth >= 990 && event.clientX > 0 && event.clientY > 0) {
          if (event.target.closest('.header__menu-toggle') || event.target.closest('.icon-caret')) {
            event.preventDefault();
            event.stopPropagation();
            if (details.hasAttribute('open')) {
              details.removeAttribute('open');
              summary.setAttribute('aria-expanded', false);
            } else {
              details.setAttribute('open', '');
              summary.setAttribute('aria-expanded', true);
            }
            return;
          }

          const url = summary.getAttribute('data-url');
          if (url && url !== '#') {
            event.preventDefault();
            event.stopPropagation();
            window.location.href = url;
          }
        }
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
